"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bar = _interopRequireDefault(require("./bar/bar"));

var _barchart_definition = _interopRequireDefault(require("./barchart_definition"));

var _definecomponent = require("../../../utils/definecomponent");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _barchart_styles = _interopRequireDefault(require("./barchart_styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// definition
// styles

/* ========== ~~~~~~~~~~ BARCHART ~~~~~~~~~~ ========== */


var BarChart = function BarChart(props) {
  var renderBars = function renderBars() {
    return props.data.map(function (bar, index) {
      return _react.default.createElement(_bar.default, {
        color: bar.color,
        y: "".concat(bar.y, "%"),
        x: bar.x,
        label: "".concat(bar.y, "%")
      });
    });
  };

  return _react.default.createElement("div", {
    className: "barchart ".concat(props.classes.barchart)
  }, renderBars());
};
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */


(0, _definecomponent.defineComponent)(BarChart, _barchart_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = (0, _reactJss.default)(_barchart_styles.default)(BarChart);

exports.default = _default;